var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:[_vm.$vuetify.breakpoint.xsOnly ? 'ma-0 pa-0' : '']},[(_vm.workRequest)?_c('WorkRequestCardPage',{attrs:{"workRequest":_vm.workRequest}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }